// Babel's regenerator runtime & core-js polyfill
require("@babel/polyfill/noConflict");

// fetch() auto-polyfill
require("whatwg-fetch");
